module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/featured_image@2x.94c4140.jpg";